import axios from 'axios';

const api = axios.create();

// Add auth token, app mode, and client view to every request
api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem('meridian_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  // View as Client sends both headers; demo mode sends only X-App-Mode
  const viewClient = localStorage.getItem('meridian_view_as_client');
  const mode = localStorage.getItem('meridian_app_mode') || 'admin';
  if (viewClient) {
    config.headers['X-Client-Name'] = viewClient;
    config.headers['X-App-Mode'] = 'demo';
  } else if (mode === 'demo') {
    config.headers['X-App-Mode'] = 'demo';
  }
  return config;
});

// On 401, clear session and redirect to login
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      sessionStorage.removeItem('meridian_token');
      const publicPaths = ['/', '/login', '/request-demo', '/faq', '/api-docs', '/privacy', '/terms', '/cookies'];
      if (!publicPaths.includes(window.location.pathname)) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
